var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    { staticClass: "invoice-header flex justify-between hidden-print" },
    [
      _c("div", { staticClass: "w-8 h-8" }, [
        _c("button", { on: { click: _vm.goBack } }, [_c("ArrowLeftIcon")], 1),
      ]),
      _c(
        "h1",
        {
          staticClass:
            "text-black-100 text-3xl font-semibold leading-none font-outfit",
        },
        [_vm._v(" " + _vm._s(_vm.message) + " ")]
      ),
      _c("div", { staticClass: "w-8 h-8" }, [
        _c(
          "button",
          { on: { click: _vm.close } },
          [_c("CrossIconBlackNew")],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }